import { usePerson } from "@/shared/hooks/useAppContext";
import { useIntakeStatus } from "@/shared/hooks/useIntakeStatus";
import { useAuthorityAnswers, getAuthorityBucket } from "@/shared/hooks/useAuthorityAnswers";

export function useAuthorityEligibility(): boolean {
  const person = usePerson();
  const estateId = person?.estate_id;
  const {
    hasCompletedIntro,
    hasEstablishedAuthority,
    isFetched: isIntakeFetched,
  } = useIntakeStatus();
  const { savedAnswers, isFetched: areAnswersFetched } = useAuthorityAnswers(estateId);

  const bucket = getAuthorityBucket(savedAnswers);

  return (
    hasCompletedIntro &&
    !hasEstablishedAuthority &&
    isIntakeFetched &&
    areAnswersFetched &&
    bucket === 1
  );
}
